import i18n from '~/utils/i18n'

import { TAG } from '~/data/dictionary'
import serializeImage from '~/data/serialize-image'
import serializeLink from '~/data/serialize-link'
import { serializeSearchContent } from '~/data/serialize-search-content'
import serializeTag from '~/data/serialize-tag'

function getCardLayoutPropsFromLayoutName(layoutName) {
  switch (layoutName) {
    case 'small':
      return {
        isSmall: true,
      }
    case 'full':
      return {
        isFullWidth: true,
      }
    default:
      return {}
  }
}

function getAttributesName(attributes) {
  if (attributes?.length) {
    return (
      attributes
        ?.filter?.((attribute) => attribute?.content?.name)
        ?.map?.((attribute) => getAttributeName(attribute)) ?? []
    )
  } else {
    return getAttributeName(attributes)
  }
}

function getAttributeName(attribute) {
  return attribute?.content?.name
}

export function serializeStoryblokAttributesData(data) {
  const content = data?.content

  return {
    vertus: getAttributesName(content?.vertus),
    significations: getAttributesName(content?.significations),
    materials: getAttributesName(content?.materials),
    colors: getAttributesName(content?.colors),
    plantExposures: getAttributesName(content?.plant_exposures),
    productEnvironments: getAttributesName(content?.product_environments),
    plantSize: getAttributesName(content?.plant_size),
    brand: getAttributesName(content?.brand),
    plantType: getAttributesName(content?.plant_type),
    productType: getAttributesName(content?.product_type),
  }
}

export function serializeStoryblokData(data, locale) {
  const content = data?.content
  const labels = []

  if (content?.product_tags) {
    content?.product_tags
      ?.filter((tag) => tag?.name && tag?.content?.name)
      ?.forEach((tag) => {
        labels.push(serializeTag({ label: tag?.content?.name }))
      })
  }

  if (content?.delivery_time) {
    const deliveryTag = serializeTag({
      label: `${i18n.t(TAG.DELIVERED_IN, {
        _: locale === 'en' ? 'Delivered in' : 'Livré en',
      })} ${content?.delivery_time}`,
    })

    labels.push(deliveryTag)
  }

  const expressDelivery = content?.delivery_time === 'express' ?? null

  const image =
    serializeImage(data?.card_image) ??
    serializeImage(content?.card_image) ??
    null

  return {
    categories:
      content?.categories
        ?.filter((category) => category?.content?.name)
        ?.map((category) => category?.content?.name) ?? [],
    meanings:
      content?.significations
        ?.filter((meaning) => meaning?.name)
        ?.map((meaning) => meaning?.name) ?? [],
    image,
    imageHover: serializeImage(content?.card_image_hover) ?? null,
    name: content?.name ?? null,
    link: serializeLink(data, locale),
    slug: data?.slug ?? null,
    labels: labels,
    expressDelivery,
    isCustomizable: !!content?.customization_type,
    searchContent: serializeSearchContent(content),
    score: content?.product_score ? parseFloat(content?.product_score) : 0,
    ...(data?.small_device_layout
      ? getCardLayoutPropsFromLayoutName(data?.small_device_layout)
      : {}),
    sublabel: data?.sublabel ?? null,
  }
}
